/**
 * A unit without an official code (product.Unit with an empty Value: 191 «بدون واحد اندازه‌گیری», which a goods card
 * saved without a unit gets, and 202 «کادر») sends its row without mu. The organisation registers such rows, so the
 * panel warns about them and never stops the save (user decision 2026-10-22). The unit list (searchselect) marks
 * such a unit with «*»; a goods card or a saved row says it through `unc` (null when there is no code).
 */
export const NO_UNIT_LABEL = '* بدون واحد اندازه‌گیری'

export const CODELESS_UNIT_HINT =
  'این واحد کد رسمی سامانه مؤدیان ندارد؛ ردیف بدون واحد اندازه‌گیری فرستاده می‌شود. اگر واحد را می‌دانید، واحدی بدون علامت * انتخاب کنید.'

const MAX_LISTED_ROWS = 10

export const isCodelessUnitLabel = (label?: unknown) =>
  typeof label === 'string' && label.trim().startsWith('*')

/**
 * The label of a unit in the invoice forms: marked «*» as the unit list marks it when the server says the unit has no
 * official code. A server that does not send `unc` yet, or a row without a unit id, keeps its label as it was.
 */
export const unitLabelOf = (
  name: string | null | undefined,
  unitId: number | null | undefined,
  source?: {unc?: string | null} | null
): string => {
  const label = (name || '').trim()
  if (!unitId || !source || !('unc' in source) || source.unc) return label
  if (label.startsWith('*')) return label
  return label ? `* ${label}` : NO_UNIT_LABEL
}

/** The 1-based numbers of the rows whose unit has no official code. */
export const codelessUnitRowNumbers = (items: {unit?: {label?: unknown} | null}[]) =>
  items
    .map((item, index) => (isCodelessUnitLabel(item.unit?.label) ? index + 1 : 0))
    .filter((rowNumber) => rowNumber > 0)

export const describeCodelessUnitRows = (rowNumbers: number[]) => {
  if (rowNumbers.length === 0) return ''
  const listed = rowNumbers.slice(0, MAX_LISTED_ROWS).join('، ')
  const more =
    rowNumbers.length > MAX_LISTED_ROWS ? ` و ${rowNumbers.length - MAX_LISTED_ROWS} ردیف دیگر` : ''
  const rows =
    rowNumbers.length === 1
      ? `ردیف ${listed} واحد اندازه‌گیری رسمی ندارد (علامت *) و بدون واحد به سامانه مؤدیان فرستاده می‌شود.`
      : `ردیف‌های ${listed}${more} واحد اندازه‌گیری رسمی ندارند (علامت *) و بدون واحد به سامانه مؤدیان فرستاده می‌شوند.`
  return (
    `${rows} ` +
    'برای افزودن واحد، ردیف را ویرایش کنید و واحدی بدون علامت * انتخاب کنید، یا واحد کالا را در کارت کالا/خدمت ثبت کنید.'
  )
}
